// Thin wrapper around gtag for GA4 enquiry events.
// gatsby-plugin-google-gtag only injects gtag in production builds,
// so this no-ops in `gatsby develop` and during SSR.
export function trackEvent(eventName, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }
  // beacon transport so events survive full-page navigations (plain <a> links)
  window.gtag("event", eventName, { transport_type: "beacon", ...params });
}
